/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: c64630f2ba2d
 */

import { streamingProfilesGetStreamingProfiles } from "../../funcs/streamingProfilesGetStreamingProfiles.js";
import { GetStreamingProfilesRequest$zodSchema } from "../../models/getstreamingprofilesop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetStreamingProfilesRequest$zodSchema.optional(),
};

export const tool$streamingProfilesGetStreamingProfiles: ToolDefinition<
  typeof args
> = {
  name: "list-streaming-profiles",
  description:
    `Lists all adaptive streaming profiles (both built-in and custom) defined in your Cloudinary account`,
  scopes: ["builder"],
  annotations: {
    "title": "List Streaming Profiles",
    "destructiveHint": false,
    "idempotentHint": true,
    "openWorldHint": false,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await streamingProfilesGetStreamingProfiles(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
